let { baseUrl, questionBaseUrl } = process.env;
//测试环境
// baseUrl = "https://pre.weiyoubot.cn";
// questionBaseUrl = 'https://pre.weiyoubot.cn';

// // 线上环境
baseUrl = "https://api-xcx.qunsou.co";
questionBaseUrl = "https://api-xcx-qunsou.weiyoubot.cn";
let test = false;
// if(test) {
  // baseUrl = 'https://pre.weiyoubot.cn'
  // questionBaseUrl = "https://pre.weiyoubot.cn"
// }
let sdkId = test ? '19850160481' : '19180159284';
let hostName = test ? 'pre' : 'meeting';
var checkin = {
  login: "/xcx/checkin_web/v1/login"
};

var question = {
  upload: "/xcx/file/v1/upload", //新增的上传文件，感觉用不上了
  uploadPic: "/xcx/file/v1/upload", //小程序的上传图片
  uploadAudio: "/xcx/audio/upload", //小程序的上传语音
  uploadVideo: "/xcx/checkin/v1/upload/video", //小程序的上传视频
  getCheckinDetail: "/xcx/checkin/v4/detail", //获取签到详情
  warehouseAdd: "/xcx/ques/v2/warehouse/item/add",
  importStatus: "/xcx/ques/v1/import_status",
  assignExcelImport: "/xcx/ques/v1/import/assign", // 指定答题名单导入
  regInfoExcelImport: "/xcx/ques/v1/reg_info/import", // 个人信息选项导入
  getServiceDetail: "/xcx/ques/v1/book_buy/detail", // 错题本购买信息详情
  bookVipBuy: "/xcx/ques/v1/order", // 错题本服务购买
  login: "/xcx/ques/v1/web/login", // 登录
  getSign: "/xcx/ques/v1/sign", // 获取sign
  getQuestionDetial: "/xcx/ques/v2/detail", // 获取答题详情
  questionSubmit: "/xcx/ques/v2/submit", // 提交答题,
  getResult: "/xcx/ques/v1/result", // 获取答题成绩
  getRank: "/xcx/ques/v1/rank", // 获取排行榜列表
  getList: "/xcx/ques/v2/list", // 获取答题列表
  getJoinStatus: "/xcx/ques/v1/match/join", // 获取答题答题人数状态
  updateJoinStatus: "/xcx/ques/v1/match/join", // 进入答题离开答题记录状态
  getStart: "/xcx/ques/v1/start", // 开启答题
  getAuthInfo: "/xcx/ques/v1/meeting/callback", // 根据auth_code获取用户信息
  checkBindStatus: "/xcx/ques/v1/meeting/bind", // 获取登录绑定状态
  getConfig: "/xcx/ques/v1/meeting/auth", // 获取鉴权所需config
  getBookDetail: '/xcx/ques/v1/book_buy/detail', // 获取错题本相关权限
  getWrongbookList: '/xcx/ques/v1/book/list' // 错题本列表
};

export default {
  baseUrl,
  checkin,
  question,
  questionBaseUrl,
  test,
  sdkId,
  hostName
};



// WEBPACK FOOTER //
// ./src/utils/api.js